import type { ReactNode } from 'react'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

// Обёртка для <tr>, которая вешает на строку поведение @dnd-kit/sortable.
// `listeners` ставим только на drag-handle (первая ячейка), а не на всю строку,
// иначе попытка кликнуть в input или выделить текст начинала бы перетаскивание.
export function SortableItemRow({
  uid,
  id,
  className,
  children,
}: {
  uid: string
  /** DOM id для якорной навигации (скролл «верх ↔ низ» в NewRequestPage). */
  id?: string
  className?: string
  children: ReactNode
}) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: uid,
  })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
    background: isDragging ? '#f9fafb' : undefined,
  }

  return (
    <tr ref={setNodeRef} id={id} style={style} className={className} {...attributes}>
      <td
        className="px-1 py-0.5 text-center align-middle cursor-grab active:cursor-grabbing select-none text-gray-300 hover:text-gray-500"
        title="Перетащить, чтобы изменить порядок"
        {...listeners}
      >
        ⋮⋮
      </td>
      {children}
    </tr>
  )
}
